import { motion } from "framer-motion";
import { Cpu } from "lucide-react";
import { useLightbox } from "@/components/Lightbox";
import { useSlowFactor } from "@/hooks/useSlowFactor";
import { useLanguage } from "@/i18n/LanguageContext";

const ACTUATOR_IMG =
  "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/yh032lcf_IMG_8926%5B1%5D%20%D1%80%D0%B5%D0%B4..JPG";

export const ActuatorSection = () => {
  const { open } = useLightbox();
  const slow = useSlowFactor();
  const { t } = useLanguage();
  return (
    <section id="actuators" data-testid="actuators-section" className="py-16 sm:py-24 lg:py-32 carbon-panel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2 * slow, ease: "easeOut" }}
          >
            <p className="text-sm font-bold uppercase tracking-[0.25em] text-red-500 mb-4 flex items-center gap-3">
              <Cpu size={16} strokeWidth={2} /> {t.actuator.eyebrow}
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight leading-tight text-white mb-6">
              {t.actuator.heading}
            </h2>
            <p className="text-lg text-zinc-300 leading-relaxed">
              {t.actuator.body}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2 * slow, ease: "easeOut" }}
            onClick={() => open(ACTUATOR_IMG, t.actuator.imgAlt)}
            className="relative aspect-square w-full max-w-[520px] mx-auto photo-frame overflow-hidden group cursor-pointer"
          >
            <img
              src={ACTUATOR_IMG}
              alt={t.actuator.imgAlt}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 bg-red-600 text-white px-5 py-3 shadow-[0_0_30px_rgba(239,68,68,0.5)]">
              <p className="font-display font-bold uppercase tracking-tight leading-none">G3-REA-MASTER</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
